import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Loader, Typography } from '@altermaind/web/ui';
import { AlertBadge } from '@/_shared/components/AlertBadge';
import { getUserProfileCall } from '@/core/state/api';
import { postEmployerByIdSurveyResultCall } from '@/surveys/state/api';
import { AssessmentResults } from '../AssessmentResults';
import { SurveyNotCompleted } from '../SurveyNotCompleted';

export const Assessment = () => {
  const t = useTranslations('assessments.page');
  const tShared = useTranslations();

  const { templateId } = useParams<{ templateId: string }>();

  const { email } = getUserProfileCall.hook();
  const {
    loading: loadingPostEmployerByIdSurveyResult,
    success: successPostEmployerByIdSurveyResult,
    error: errorPostEmployerByIdSurveyResult,
    execute: executePostEmployerByIdSurveyResult,
    response: responsePostEmployerByIdSurveyResult,
  } = postEmployerByIdSurveyResultCall.hook();

  const templateName =
    responsePostEmployerByIdSurveyResult?.find(survey => survey.templateId === templateId)
      ?.templateName || '';

  useEffect(() => {
    executePostEmployerByIdSurveyResult({
      username: email,
    });
  }, [email, executePostEmployerByIdSurveyResult]);

  if (loadingPostEmployerByIdSurveyResult) {
    return (
      <Box mt='s' textAlign='center'>
        <Loader size='s' />
      </Box>
    );
  }

  if (errorPostEmployerByIdSurveyResult) {
    const message = tShared('errors.genericApiError');
    return <AlertBadge iconName='info' type='error' label={message} />;
  }

  if (
    successPostEmployerByIdSurveyResult &&
    !loadingPostEmployerByIdSurveyResult &&
    !errorPostEmployerByIdSurveyResult
  ) {
    const hasCompletedThisTemplate = responsePostEmployerByIdSurveyResult?.some(
      survey => survey.templateId === templateId && survey.completed,
    );

    return (
      <Box>
        {hasCompletedThisTemplate ? (
          <>
            <Box
              display='flex'
              flexDirection='row'
              justifyContent='space-between'
              alignItems='center'
            >
              <Typography mb='s' variant='h1'>
                {t('title', { templateName })}
              </Typography>
            </Box>
            <AssessmentResults templateId={templateId} />
          </>
        ) : (
          <SurveyNotCompleted templateId={templateId} />
        )}
      </Box>
    );
  }

  return null;
};
